<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-25 18:35:03
 -->
<template>
  <div class="box">
    <div class="video_div" :class="[playClass ? 'has_play_img' : '']">
      <div class="register_div" v-if="status == 'end'">
        <p>请登录后继续观看视频！</p>
        <div @click="toRegister">登录</div>
      </div>
      <video
        v-else-if="status == 'living'"
        ref="video"
        id="ele_video"
        :poster="detailObj.coverPic"
        controls="controls"
        :src="status == 'living' ? detailObj.livingUrl : ''"
        playsinline="true"
        webkit-playsinline="true"
        x-webkit-airplay="true"
        x5-playsinline
      ></video>
      <img v-if="status != 'living'" :src="detailObj.coverPic" />
    </div>
    <div class="before_box" v-if="status == 'before'">
      <p class="p1">直播时间</p>
      <p class="p2">
        {{ (detailObj.liveStartTime - 10 * 60 * 1000) | transMonth }}
      </p>
    </div>
    <div class="after_box" v-else-if="status == 'after'">
      <p class="p1">直播已结束</p>
      <p class="p1">来医学V视界发现更多精彩</p>
      <p class="goHome" @click="goHome">前往</p>
    </div>
  </div>
</template>

<script>
// TODO: vux
import { XButton } from 'vux';
import { live } from '@/api/ajax.js';
import { mapState } from 'vuex';

import { contentview } from '@/Mixin/contentview.js';

export default {
  name: '',
  mixins: [contentview],
  props: {
    categoriesArr: {
      type: Array,
      default() {
        return [];
      }
    },
    detailObj: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      controls: false,
      playClass: false,
      status: '',
      end: {},
      sign: false,
      scType: '',
      shareCount: 0
    };
  },
  methods: {
    jump(id) {
      this.$router.push({
        name: 'courseDetail',
        params: {
          id: id
        }
      });
    },
    goHome() {
      this.$router.push({
        name: 'home'
      });
    },
    toRegister() {
      this.$router.push({ name: 'register' });
    },
    /*
     * 判断直播状态 直播前 中 后
     * */
    liveStatus() {
      if (this.status != 'end') {
        if (
          new Date().getTime() + 60 * 1000 * 10 <
          this.detailObj.liveStartTime
        ) {
          this.status = 'before';
        } else if (
          new Date().getTime() + 60 * 1000 * 10 >
            this.detailObj.liveStartTime &&
          new Date().getTime() < this.detailObj.liveEndTime
        ) {
          this.status = 'living';
        } else {
          this.status = 'after';
        }
      }
    },
    /*
     * vide 初始化  主要对于微信中android ios 的不同处理
     * */
    videInfo() {
      //        if (this.$api.kernel() == 'wx' && this.$api.ios() == 'ios') {
      //          this.controls = true
      //
      //        } else {
      //          this.playClass = true
      //        }
    }
  },
  components: {
    XButton
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  watch: {
    detailObj(val) {
      let fn = () => {
        setTimeout(() => {
          // 新用户试看三分钟
          if (this.status == 'living') {
            this.$refs.video.pause();
            this.status = 'end';
            this.$vux.toast.show({
              type: 'text',
              text: '未注册用户只能试看3分钟',
              position: 'top',
              width: '8rem'
            });

            if (this.sendReportInter) {
              clearInterval(this.sendReportInter);
            }
          }
        }, 3 * 60 * 1000);
      };
      this.$nextTick(() => {
        this.pageStayTime('直播', this.liveStatus);
        this.videoPlay('直播', fn);
      });
    }
  },
  mounted() {
    this.scType = this.$route.query.shequn ? 'shequn' : 'share';
  }
};
</script>

<style scoped lang="less">
@import '../../../public/style/g.less';
.hide {
  display: none;
}
.sc_div {
  width: 8rem;
  height: 8.88rem;
  background: url(//cdn.yxvzb.com/img/course/Rectan1.png) no-repeat;
  background-size: 100%;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -4rem;
  padding-top: 0.8rem;
  text-align: center;
  h1 {
    font-size: 0.426667rem;
    width: 3rem;
    margin: auto;
    font-weight: normal;
    color: #161616;
  }
  p {
    font-size: 0.4rem;
    width: 5.7rem;
    margin: auto;
    text-align: left;
  }
  .sc_p {
    margin: 0.7333rem auto;
  }
  .ikbt {
    width: 5.1333rem;
    height: 1.1733rem;
    border-radius: 0.08rem;
    background: #027cfa;
    margin: auto;
    color: #fff;
    text-align: center;
    font-size: 0.4rem;
    line-height: 1.1733rem;
    margin-top: 0.8rem;
  }
  .sc_pb {
    position: relative;
  }
  .sc_pb:before {
    content: '';
    position: absolute;
    top: 0.3rem;
    left: -0.3rem;
    width: 0.15rem;
    height: 0.15rem;
    border-radius: 50%;
    background: #027af6;
  }
}
.sc_div:before {
  content: '';
  width: 3.6rem;
  height: 2.6666rem;
  background: url(//cdn.yxvzb.com/img/course/Grou2.png) no-repeat;
  background-size: 100%;
  position: absolute;
  right: -1.3rem;
  top: -1.1rem;
}
.box {
  position: relative;
  .video_div {
    width: 100%;
    height: 5.6266rem;
    position: relative;
    * {
      max-width: 100%;
      height: 5.6266rem;
    }
    #ele_video {
      width: 100%;
      height: 5.6266rem;
    }
    .register_div {
      width: 5.65rem;
      height: 3.33rem;
      border-radius: 0.13rem;
      background: rgba(255, 255, 255, 0.95);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding-top: 0.85rem;
      padding-bottom: 0.59rem;
      p {
        font-size: 0.43rem;
        color: #333333;
        text-align: center;
        margin-bottom: 0.49rem;
        height: 0.6428rem;
      }
      div {
        width: 2.67rem;
        height: 0.8rem;
        background: #027cfa;
        border-radius: 0.11rem;
        text-align: center;
        line-height: 0.8rem;
        font-size: 0.4rem;
        color: #ffffff;
        margin: auto;
      }
    }
  }
  .has_play_img:before {
    content: '';
    background: url('//cdn.yxvzb.com/img/playimg.png') no-repeat;
    background-size: 100%;
    width: 2rem;
    height: 2rem;
    position: absolute;
    top: 1.5rem;
    left: 50%;
    z-index: 2;
    margin-left: -1rem;
  }
  .before_box {
    width: 56%;
    padding: 0.4rem 0;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 0.1rem;
    position: absolute;
    top: 20%;
    left: 22%;
    text-align: center;
    z-index: 10;
    .sign {
      background-image: linear-gradient(-90deg, #027cfa 0%, #2cb9ff 100%);
      border-radius: 0.08rem;
      width: 3.2rem;
      height: 0.8rem;
      color: #fff;
      font-size: 0.3733rem;
      margin-top: 0.5rem;
    }
    .p2 {
      font-size: 0.4266rem;
      color: #027cfa;
      margin-top: 0.2rem;
    }
  }
  .after_box {
    width: 100%;
    height: 100%;
    padding: 0.5333rem 0.4rem;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 0.1rem;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    z-index: 10;
    .p1 {
      font-size: 0.453rem; // font-weight: bold;
      color: #fff;
      text-align: center;
    }
    p:first-of-type {
      margin-top: 0.5rem;
    }
    .goHome {
      color: #fff;
      width: 2.107rem;
      height: 0.907rem;
      background: #027cfa;
      margin: 0 auto;
      line-height: 0.907rem;
      margin-top: 0.3rem;
      border-radius: 3px;
      font-size: 0.4rem;
    }
  }
}
</style>
